import { useContext, useEffect } from 'react';
import { useToast } from '../../contexts/ToastContext';
import { PagesContext } from '../../contexts/PagesContext';
import { PageStatusEnum } from '../../enums/PageStatusEnum';

interface CheckPageStatusesProps {
  noAutoRefresh?: boolean;
}

export default function CheckPageStatuses({ noAutoRefresh = false }: CheckPageStatusesProps) {
  const { showToast } = useToast();
  const {
    pageDatas,
    pageDatasSnapshot,
    getPageList,
    checkForStatus,
    clearApiInterval,
  } = useContext(PagesContext);

  useEffect(() => {
    if (pageDatas.length > 0) {
      pageDatas.forEach((pageData) => {
        if (pageData.status === PageStatusEnum.PROCESSING) {
          checkForStatus(pageData.id);
        }
      });
    }

    return () => {
      // Clear interval on unmount
      if (pageDatas.length > 0) {
        pageDatas.forEach((pageData) => {
          clearApiInterval(pageData.id);
        });
      }
    };
  }, [checkForStatus, clearApiInterval, pageDatas]);

  // Check page status changes every 5 seconds if prop is not set
  useEffect(() => {
    if (!noAutoRefresh) {
      setInterval(() => {
        getPageList({ is_user_sites: true });
      }, 5000);
    }

    // Check each page data from snapshot for changes
    if (pageDatasSnapshot) {
      pageDatas.forEach((pageData) => {
        const snapshotData = Array.isArray(pageDatasSnapshot) ? pageDatasSnapshot.find((data) => data.id === pageData.id) : undefined;

        if (snapshotData && snapshotData?.status) {
          if (snapshotData.status !== pageData.status) {
            switch (pageData.status) {
              case PageStatusEnum.PRIVATE:
                showToast(`${pageData.page_setting.custom_url ?? pageData.page_setting.url} - 非公開されました。`, 'success');
                break;
              case PageStatusEnum.PUBLIC:
                showToast(`${pageData.page_setting.custom_url ?? pageData.page_setting.url} - 公開されました`, 'success');
                break;
              case PageStatusEnum.FAILED:
                showToast(`${pageData.page_setting.custom_url ?? pageData.page_setting.url} - ${pageData.last_error}`, 'danger');
                break;
              default:
                break;
            }
          }
        }
      });
    }
  }, [pageDatas, pageDatasSnapshot, showToast, noAutoRefresh, getPageList]);

  return (
    <></>
  );
}
